import React from "react";
import {
  BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import type { LocationPerf } from "../../types/dashboard.types";

interface Props {
  locations: LocationPerf[];
}

const ImpressionsBarChart: React.FC<Props> = ({ locations }) => {
  const data = locations
    .filter(l => !l.error)
    .sort((a, b) => (b.kpis?.totalImpressions ?? 0) - (a.kpis?.totalImpressions ?? 0))
    .slice(0, 8)
    .map(l => ({
      name:        (l.title ?? l.locationName).split(" ").slice(0, 3).join(" "),
      impressions: l.kpis?.totalImpressions ?? 0,
      appels:      l.kpis?.callClicks       ?? 0,
    }));

  if (!data.length) return null;

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
      <div className="mb-4">
        <h3 className="text-[13px] font-bold text-slate-700">Impressions par fiche</h3>
        <p className="text-[11px] text-slate-400">Top {data.length} établissements</p>
      </div>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data} margin={{ top: 0, right: 8, bottom: 0, left: -20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 9, fill: "#94a3b8" }} />
          <YAxis tick={{ fontSize: 10, fill: "#94a3b8" }} />
          <Tooltip
            contentStyle={{ fontSize: 11, borderRadius: 10, border: "1px solid #e2e8f0" }}
          />
          <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="impressions" name="Impressions" fill="#0F52BA" radius={[4, 4, 0, 0]} opacity={0.85} />
          <Bar dataKey="appels"      name="Appels"      fill="#EA7A1E" radius={[4, 4, 0, 0]} opacity={0.85} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ImpressionsBarChart;